import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { Overline, FadeIn } from "@/components/site/Shared";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="py-24 sm:py-32 border-b border-line">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <FadeIn>
            <Overline className="mb-5">Insights</Overline>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter text-white leading-[0.95] max-w-4xl">
              From The Field &<br /><span className="text-ember">The Drawing Board</span>
            </h1>
            <p className="text-silver max-w-2xl mt-8 leading-relaxed">
              Practical guidance on contracts, billing, engineering and site operations — written by the people who build, for the people who commission.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-8">
          {posts.map((b, i) => (
            <FadeIn key={b.slug} delay={(i % 2) * 0.08}>
              <Link to={`/blog/${b.slug}`} data-testid={`blog-list-card-${b.slug}`} className="group block border border-line bg-graphite lift h-full">
                <div className="img-zoom overflow-hidden h-64"><img src={b.image} alt={b.title} className="w-full h-full object-cover" /></div>
                <div className="p-8">
                  <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em]">
                    <span className="text-ember font-bold">{b.category}</span>
                    <span className="text-silver">{b.date}</span>
                  </div>
                  <h3 className="font-heading text-2xl text-white mt-4 leading-snug group-hover:text-ember transition-colors duration-200">{b.title}</h3>
                  <p className="text-silver text-sm mt-4 leading-relaxed">{b.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white font-bold">Read Article <ArrowUpRight size={13} className="text-ember" /></span>
                </div>
              </Link>
            </FadeIn>
          ))}
        </div>
      </section>
    </div>
  );
}
